/**
 *
 * @param {Object} state
 * @param {Object} store code
 */
const SET_STORE_CODE = (state, storeCode) => {
  state.storeCode = storeCode;
};

const SET_PAYPAL_METHOD_NAME = (state, paypalMethodName) => {
  state.paypalMethodName = paypalMethodName;
};

export default {
  SET_STORE_CODE,
  SET_PAYPAL_METHOD_NAME
};
